(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.localizedAddressFormat = {}));
})(this, (function (exports) { 'use strict';

    // This file is auto-generated via "npm run update-formats". Do not alter manually!
    const addressFormats = new Map([
        ['AC', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['AD', { local: '%N%n%O%n%A%n%Z %C' }],
        ['AE', { local: '%N%n%O%n%A%n%S', latin: '%N%n%O%n%A%n%S' }],
        ['AF', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['AI', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['AL', { local: '%N%n%O%n%A%n%Z%n%C' }],
        ['AM', { local: '%N%n%O%n%A%n%Z%n%C%n%S', latin: '%N%n%O%n%A%n%Z%n%C%n%S' }],
        ['AR', { local: '%N%n%O%n%A%n%Z %C%n%S' }],
        ['AS', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['AT', { local: '%O%n%N%n%A%n%Z %C' }],
        ['AU', { local: '%O%n%N%n%A%n%C %S %Z' }],
        ['AX', { local: '%O%n%N%n%A%nAX-%Z %C%nÅLAND' }],
        ['AZ', { local: '%N%n%O%n%A%nAZ %Z %C' }],
        ['BA', { local: '%N%n%O%n%A%n%Z %C' }],
        ['BB', { local: '%N%n%O%n%A%n%C, %S %Z' }],
        ['BD', { local: '%N%n%O%n%A%n%C - %Z' }],
        ['BE', { local: '%O%n%N%n%A%n%Z %C' }],
        ['BF', { local: '%N%n%O%n%A%n%C %X' }],
        ['BG', { local: '%N%n%O%n%A%n%Z %C' }],
        ['BH', { local: '%N%n%O%n%A%n%C %Z' }],
        ['BL', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['BM', { local: '%N%n%O%n%A%n%C %Z' }],
        ['BN', { local: '%N%n%O%n%A%n%C %Z' }],
        ['BR', { local: '%O%n%N%n%A%n%D%n%C-%S%n%Z' }],
        ['BS', { local: '%N%n%O%n%A%n%C, %S' }],
        ['BT', { local: '%N%n%O%n%A%n%C %Z' }],
        ['BY', { local: '%O%n%N%n%A%n%Z, %C%n%S' }],
        ['CA', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['CC', { local: '%O%n%N%n%A%n%C %S %Z' }],
        ['CH', { local: '%O%n%N%n%A%nCH-%Z %C' }],
        ['CI', { local: '%N%n%O%n%X %A %C %X' }],
        ['CL', { local: '%N%n%O%n%A%n%Z %C%n%S' }],
        ['CN', { local: '%Z%n%S%C%D%n%A%n%O%n%N', latin: '%N%n%O%n%A%n%D%n%C%n%S, %Z' }],
        ['CO', { local: '%N%n%O%n%A%n%D%n%C, %S, %Z' }],
        ['CR', { local: '%N%n%O%n%A%n%S, %C%n%Z' }],
        ['CU', { local: '%N%n%O%n%A%n%C %S%n%Z' }],
        ['CV', { local: '%N%n%O%n%A%n%Z %C%n%S' }],
        ['CX', { local: '%O%n%N%n%A%n%C %S %Z' }],
        ['CY', { local: '%N%n%O%n%A%n%Z %C' }],
        ['CZ', { local: '%N%n%O%n%A%n%Z %C' }],
        ['DE', { local: '%N%n%O%n%A%n%Z %C' }],
        ['DK', { local: '%N%n%O%n%A%n%Z %C' }],
        ['DO', { local: '%N%n%O%n%A%n%Z %C' }],
        ['DZ', { local: '%N%n%O%n%A%n%Z %C' }],
        ['EC', { local: '%N%n%O%n%A%n%Z%n%C' }],
        ['EE', { local: '%N%n%O%n%A%n%Z %C %S' }],
        ['EG', { local: '%N%n%O%n%A%n%C%n%S%n%Z', latin: '%N%n%O%n%A%n%C%n%S%n%Z' }],
        ['EH', { local: '%N%n%O%n%A%n%Z %C' }],
        ['ES', { local: '%N%n%O%n%A%n%Z %C %S' }],
        ['ET', { local: '%N%n%O%n%A%n%Z %C' }],
        ['FI', { local: '%O%n%N%n%A%nFI-%Z %C' }],
        ['FK', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['FM', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['FO', { local: '%N%n%O%n%A%nFO%Z %C' }],
        ['FR', { local: '%O%n%N%n%A%n%Z %C' }],
        ['GB', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['GE', { local: '%N%n%O%n%A%n%Z %C' }],
        ['GF', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['GG', { local: '%N%n%O%n%A%n%C%nGUERNSEY%n%Z' }],
        ['GI', { local: '%N%n%O%n%A%nGIBRALTAR%n%Z' }],
        ['GL', { local: '%N%n%O%n%A%n%Z %C' }],
        ['GN', { local: '%N%n%O%n%Z %A %C' }],
        ['GP', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['GR', { local: '%N%n%O%n%A%n%Z %C' }],
        ['GS', { local: '%N%n%O%n%A%n%n%C%n%Z' }],
        ['GT', { local: '%N%n%O%n%A%n%Z- %C' }],
        ['GU', { local: '%N%n%O%n%A%n%C %Z' }],
        ['GW', { local: '%N%n%O%n%A%n%Z %C' }],
        ['HK', { local: '%S%n%C%n%A%n%O%n%N', latin: '%N%n%O%n%A%n%C%n%S' }],
        ['HM', { local: '%O%n%N%n%A%n%C %S %Z' }],
        ['HN', { local: '%N%n%O%n%A%n%C, %S%n%Z' }],
        ['HR', { local: '%N%n%O%n%A%nHR-%Z %C' }],
        ['HT', { local: '%N%n%O%n%A%nHT%Z %C' }],
        ['HU', { local: '%N%n%O%n%C%n%A%n%Z' }],
        ['ID', { local: '%N%n%O%n%A%n%C%n%S %Z' }],
        ['IE', { local: '%N%n%O%n%A%n%D%n%C%n%S%n%Z' }],
        ['IL', { local: '%N%n%O%n%A%n%C %Z' }],
        ['IM', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['IN', { local: '%N%n%O%n%A%n%C %Z%n%S' }],
        ['IO', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['IQ', { local: '%O%n%N%n%A%n%C, %S%n%Z' }],
        ['IR', { local: '%O%n%N%n%S%n%C, %D%n%A%n%Z' }],
        ['IS', { local: '%N%n%O%n%A%n%Z %C' }],
        ['IT', { local: '%N%n%O%n%A%n%Z %C %S' }],
        ['JE', { local: '%N%n%O%n%A%n%C%nJERSEY%n%Z' }],
        ['JM', { local: '%N%n%O%n%A%n%C%n%S %X' }],
        ['JO', { local: '%N%n%O%n%A%n%C %Z' }],
        ['JP', { local: '〒%Z%n%S%n%A%n%O%n%N', latin: '%N%n%O%n%A, %S%n%Z' }],
        ['KE', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['KG', { local: '%N%n%O%n%A%n%Z %C' }],
        ['KH', { local: '%N%n%O%n%A%n%C %Z' }],
        ['KI', { local: '%N%n%O%n%A%n%S%n%C' }],
        ['KN', { local: '%N%n%O%n%A%n%C, %S' }],
        ['KP', { local: '%Z%n%S%n%C%n%A%n%O%n%N', latin: '%N%n%O%n%A%n%C%n%S, %Z' }],
        ['KR', { local: '%S %C%D%n%A%n%O%n%N%n%Z', latin: '%N%n%O%n%A%n%D%n%C%n%S%n%Z' }],
        ['KW', { local: '%N%n%O%n%A%n%Z %C' }],
        ['KY', { local: '%N%n%O%n%A%n%S %Z' }],
        ['KZ', { local: '%Z%n%S%n%C%n%A%n%O%n%N' }],
        ['LA', { local: '%N%n%O%n%A%n%Z %C' }],
        ['LB', { local: '%N%n%O%n%A%n%C %Z' }],
        ['LI', { local: '%O%n%N%n%A%nFL-%Z %C' }],
        ['LK', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['LR', { local: '%N%n%O%n%A%n%Z %C' }],
        ['LS', { local: '%N%n%O%n%A%n%C %Z' }],
        ['LT', { local: '%O%n%N%n%A%nLT-%Z %C %S' }],
        ['LU', { local: '%O%n%N%n%A%nL-%Z %C' }],
        ['LV', { local: '%N%n%O%n%A%n%S%n%C, %Z' }],
        ['MA', { local: '%N%n%O%n%A%n%Z %C' }],
        ['MC', { local: '%N%n%O%n%A%nMC-%Z %C %X' }],
        ['MD', { local: '%N%n%O%n%A%nMD-%Z %C' }],
        ['ME', { local: '%N%n%O%n%A%n%Z %C' }],
        ['MF', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['MG', { local: '%N%n%O%n%A%n%Z %C' }],
        ['MH', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['MK', { local: '%N%n%O%n%A%n%Z %C' }],
        ['MM', { local: '%N%n%O%n%A%n%C, %Z' }],
        ['MN', { local: '%N%n%O%n%A%n%C%n%S %Z' }],
        ['MO', { local: '%A%n%O%n%N', latin: '%N%n%O%n%A' }],
        ['MP', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['MQ', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['MT', { local: '%N%n%O%n%A%n%C %Z' }],
        ['MU', { local: '%N%n%O%n%A%n%Z%n%C' }],
        ['MV', { local: '%N%n%O%n%A%n%C %Z' }],
        ['MW', { local: '%N%n%O%n%A%n%C %X' }],
        ['MX', { local: '%N%n%O%n%A%n%D%n%Z %C, %S' }],
        ['MY', { local: '%N%n%O%n%A%n%D%n%Z %C%n%S' }],
        ['MZ', { local: '%N%n%O%n%A%n%Z %C%S' }],
        ['NA', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['NC', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['NE', { local: '%N%n%O%n%A%n%Z %C' }],
        ['NF', { local: '%O%n%N%n%A%n%C %S %Z' }],
        ['NG', { local: '%N%n%O%n%A%n%D%n%C %Z%n%S' }],
        ['NI', { local: '%N%n%O%n%A%n%Z%n%C, %S' }],
        ['NL', { local: '%O%n%N%n%A%n%Z %C' }],
        ['NO', { local: '%N%n%O%n%A%n%Z %C' }],
        ['NP', { local: '%N%n%O%n%A%n%C %Z' }],
        ['NR', { local: '%N%n%O%n%A%n%S' }],
        ['NZ', { local: '%N%n%O%n%A%n%D%n%C %Z' }],
        ['OM', { local: '%N%n%O%n%A%n%Z%n%C' }],
        ['PA', { local: '%N%n%O%n%A%n%C%n%S' }],
        ['PE', { local: '%N%n%O%n%A%n%C %Z%n%S' }],
        ['PF', { local: '%N%n%O%n%A%n%Z %C %S' }],
        ['PG', { local: '%N%n%O%n%A%n%C %Z %S' }],
        ['PH', { local: '%N%n%O%n%A%n%D, %C%n%Z %S' }],
        ['PK', { local: '%N%n%O%n%A%n%D%n%C-%Z' }],
        ['PL', { local: '%N%n%O%n%A%n%Z %C' }],
        ['PM', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['PN', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['PR', { local: '%N%n%O%n%A%n%C PR %Z' }],
        ['PT', { local: '%N%n%O%n%A%n%Z %C' }],
        ['PW', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['PY', { local: '%N%n%O%n%A%n%Z %C' }],
        ['RE', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['RO', { local: '%N%n%O%n%A%n%Z %S %C' }],
        ['RS', { local: '%N%n%O%n%A%n%Z %C' }],
        ['RU', { local: '%N%n%O%n%A%n%C%n%S%n%Z', latin: '%N%n%O%n%A%n%C%n%S%n%Z' }],
        ['SA', { local: '%N%n%O%n%A%n%C %Z' }],
        ['SC', { local: '%N%n%O%n%A%n%C%n%S' }],
        ['SD', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['SE', { local: '%O%n%N%n%A%nSE-%Z %C' }],
        ['SG', { local: '%N%n%O%n%A%nSINGAPORE %Z' }],
        ['SH', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['SI', { local: '%N%n%O%n%A%nSI-%Z %C' }],
        ['SJ', { local: '%N%n%O%n%A%n%Z %C' }],
        ['SK', { local: '%N%n%O%n%A%n%Z %C' }],
        ['SM', { local: '%N%n%O%n%A%n%Z %C' }],
        ['SN', { local: '%N%n%O%n%A%n%Z %C' }],
        ['SO', { local: '%N%n%O%n%A%n%C, %S %Z' }],
        ['SR', { local: '%N%n%O%n%A%n%C%n%S' }],
        ['SV', { local: '%N%n%O%n%A%n%Z-%C%n%S' }],
        ['SZ', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['TA', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['TC', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['TH', { local: '%N%n%O%n%A%n%D %C%n%S %Z', latin: '%N%n%O%n%A%n%D, %C%n%S %Z' }],
        ['TJ', { local: '%N%n%O%n%A%n%Z %C' }],
        ['TM', { local: '%N%n%O%n%A%n%Z %C' }],
        ['TN', { local: '%N%n%O%n%A%n%Z %C' }],
        ['TR', { local: '%N%n%O%n%A%n%Z %C/%S' }],
        ['TV', { local: '%N%n%O%n%A%n%C%n%S' }],
        ['TW', { local: '%Z%n%S%C%n%A%n%O%n%N', latin: '%N%n%O%n%A%n%C, %S %Z' }],
        ['TZ', { local: '%N%n%O%n%A%n%Z %C' }],
        ['UA', { local: '%N%n%O%n%A%n%C%n%S%n%Z', latin: '%N%n%O%n%A%n%C%n%S%n%Z' }],
        ['UM', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['US', { local: '%N%n%O%n%A%n%C, %S %Z' }],
        ['UY', { local: '%N%n%O%n%A%n%Z %C %S' }],
        ['UZ', { local: '%N%n%O%n%A%n%Z %C%n%S' }],
        ['VA', { local: '%N%n%O%n%A%n%Z %C' }],
        ['VC', { local: '%N%n%O%n%A%n%C %Z' }],
        ['VE', { local: '%N%n%O%n%A%n%C %Z, %S' }],
        ['VG', { local: '%N%n%O%n%A%n%C%n%Z' }],
        ['VI', { local: '%N%n%O%n%A%n%C %S %Z' }],
        ['VN', { local: '%N%n%O%n%A%n%C%n%S %Z', latin: '%N%n%O%n%A%n%C%n%S %Z' }],
        ['WF', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['XK', { local: '%N%n%O%n%A%n%Z %C' }],
        ['YT', { local: '%O%n%N%n%A%n%Z %C %X' }],
        ['ZA', { local: '%N%n%O%n%A%n%D%n%C%n%Z' }],
        ['ZM', { local: '%N%n%O%n%A%n%Z %C' }],
    ]);
    const defaultAddressFormat = '%N%n%O%n%A%n%C';

    const getFormatString = (countryCode, scriptType) => {
        var _a;
        const format = addressFormats.get(countryCode.toUpperCase());
        if (!format) {
            return defaultAddressFormat;
        }
        return (_a = format[scriptType]) !== null && _a !== void 0 ? _a : format.local;
    };
    const getFormatSubstrings = (format) => {
        const parts = [];
        let escaped = false;
        let currentLiteral = '';
        for (const char of format) {
            if (escaped) {
                escaped = false;
                parts.push(`%${char}`);
                continue;
            }
            if (char !== '%') {
                currentLiteral += char;
                continue;
            }
            if (currentLiteral.length > 0) {
                parts.push(currentLiteral);
                currentLiteral = '';
            }
            escaped = true;
        }
        if (currentLiteral.length > 0) {
            parts.push(currentLiteral);
        }
        return parts;
    };
    const fields = new Map([
        ['%N', 'name'],
        ['%O', 'organization'],
        ['%A', 'addressLines'],
        ['%D', 'dependentLocality'],
        ['%C', 'locality'],
        ['%S', 'administrativeArea'],
        ['%Z', 'postalCode'],
        ['%X', 'sortingCode'],
        ['%R', 'postalCountry'],
    ]);
    const getFieldForFormatSubstring = (formatSubstring) => {
        const field = fields.get(formatSubstring);
        /* istanbul ignore next imported format strings should never contain invalid substrings */
        if (!field) {
            throw new Error(`Could not find field for format substring ${formatSubstring}`);
        }
        return field;
    };
    const addressHasValueForField = (address, field) => {
        if (field === 'addressLines') {
            return address.addressLines !== undefined && address.addressLines.length > 0;
        }
        return address[field] !== undefined && address[field] !== '';
    };
    const formatSubstringRepresentsField = (formatSubstring) => {
        return formatSubstring !== '%n' && formatSubstring.startsWith('%');
    };
    const pruneFormat = (formatSubstrings, address) => {
        const prunedFormat = [];
        for (const [i, formatSubstring] of formatSubstrings.entries()) {
            // Always keep the newlines.
            if (formatSubstring === '%n') {
                prunedFormat.push(formatSubstring);
                continue;
            }
            if (formatSubstringRepresentsField(formatSubstring)) {
                // Always keep non-empty address fields.
                if (addressHasValueForField(address, getFieldForFormatSubstring(formatSubstring))) {
                    prunedFormat.push(formatSubstring);
                }
                continue;
            }
            // Only keep literals that satisfy these two conditions:
            // 1. Not preceding an empty field.
            // 2. Not following a removed field.
            if ((i === formatSubstrings.length - 1
                || formatSubstrings[i + 1] === '%n'
                || addressHasValueForField(address, getFieldForFormatSubstring(formatSubstrings[i + 1]))) && (i === 0
                || !formatSubstringRepresentsField(formatSubstrings[i - 1])
                || (prunedFormat.length > 0 && formatSubstringRepresentsField(prunedFormat[prunedFormat.length - 1])))) {
                prunedFormat.push(formatSubstring);
            }
        }
        return prunedFormat;
    };
    const formatAddress = (address, scriptType = 'local') => {
        var _a;
        const formatString = getFormatString((_a = address.postalCountry) !== null && _a !== void 0 ? _a : 'ZZ', scriptType);
        const formatSubstrings = getFormatSubstrings(formatString);
        const prunedFormat = pruneFormat(formatSubstrings, address);
        const lines = [];
        let currentLine = '';
        for (const formatSubstring of prunedFormat) {
            if (formatSubstring === '%n') {
                if (currentLine.length > 0) {
                    lines.push(currentLine);
                    currentLine = '';
                }
                continue;
            }
            if (!formatSubstringRepresentsField(formatSubstring)) {
                // Not a symbol we recognize, so must be a literal. We append it unchanged.
                currentLine += formatSubstring;
                continue;
            }
            const field = getFieldForFormatSubstring(formatSubstring);
            /* istanbul ignore next imported format strings should never contain the postal country */
            if (field === 'postalCountry') {
                // Country name is treated separately.
                continue;
            }
            if (field === 'addressLines') {
                // The field "address lines" represents the address lines of an address, so there can be multiple values.
                // It is safe to assert addressLines to be defined here, as the pruning process already checked for that.
                const addressLines = address.addressLines.filter(addressLine => addressLine !== '');
                if (addressLines.length === 0) {
                    // Empty address lines are ignored.
                    continue;
                }
                currentLine += addressLines[0];
                if (addressLines.length > 1) {
                    lines.push(currentLine);
                    currentLine = '';
                    lines.push(...addressLines.slice(1));
                }
                continue;
            }
            // Any other field can be appended as is.
            currentLine += address[field];
        }
        if (currentLine.length > 0) {
            lines.push(currentLine);
        }
        return lines;
    };

    exports.formatAddress = formatAddress;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
